import {
  isFeatureSubscribed,
  isFeatureExpired,
  isWorldTenant,
  getSubscription,
} from '../../../../Utils/Auth/ValidatePermissions';
/**
 * Checks feature subscribed should enable
 * @param {Object} feature - The feature object to check
 * @param {Object} featurePermission - The feature permission object containing subscription information
 * @returns {boolean}
 */
export const isButtonEnabled = ({
  feature,
  featurePermission,
  isOrganizationAdmin,
  isOrganizationProduct,
  tenantID,
}) => {
  return (
    !feature?.IsEnabled ||
    isFeatureSubscribed(feature) ||
    isFeatureExpired(featurePermission?.SubscriptionEndDate) ||
    (isOrganizationProduct && !isOrganizationAdmin) ||
    isWorldTenant(tenantID)
  );
};
/**
 * Checks this feature should show the Subscribed Label or not
 * @param {Object} feature - The feature object to check
 * @param {Object} featurePermission - The feature permission object containing subscription information
 * @returns {boolean} - True if feature is subscribed and not expired
 */
export const showSubscribedLabel = ({ feature, featurePermission }) => {
  return (
    isFeatureSubscribed(feature) &&
    !isFeatureExpired(featurePermission?.SubscriptionEndDate)
  );
};
/**
 * Checks this feature should show the Subscribed Label or not
 * @param {Object} feature - The feature object to check
 * @param {Object} featurePermission - The feature permission object containing subscription information
 * @returns {boolean} - True if feature is subscribed and not expired
 */
export const showExpiredLabel = ({ featurePermission }) => {
  return isFeatureExpired(featurePermission?.SubscriptionEndDate);
};
/**
 * Checks this feature should show the expiration date or not
 * @param {Object} feature - The feature object to check
 * @param {Object} featurePermission - The feature permission object containing subscription information
 * @returns {boolean}
 */
export const showFeatureExpirationDate = ({ feature, featurePermission }) => {
  return (
    feature?.Permissions?.length > 0 && featurePermission?.SubscriptionEndDate
  );
};

/**
 * Checks this subscribed button title should show or not
 * @param {Object} feature - The feature object to check
 * @returns {boolean}
 */
export const showButtonTitle = ({ feature }) => {
  return !feature?.IsEnabled && !isFeatureSubscribed(feature);
};
